/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { useEffect, useState } from "react";
import { Sheet } from "react-modal-sheet";
import styles from "src/features/Event/components/DateTimeSelectorOfFilterModalSheet/dateTimeSelectorOfFilterModalSheet.module.css";
import baseStyles from "src/global.module.css";
import CalendarIcon from "src/assets/icon/calender_icon.svg";
import { DayPicker } from "react-day-picker";
import { ja } from "date-fns/locale";
import { format } from "date-fns";
import { useAtom } from "jotai";
import {
    datePickerSelectedRangeAtom,
    displaySearchDateAtom,
    searchDateActiveIndexAtom,
} from "../../event.atom";
import "react-day-picker/dist/style.css";

const DateTimeSelectorOfFilterModalSheet: React.FC = () => {
    const [isModalOpen, setModalOpen] = useState(false);

    const handleModalOpen = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const [buttonText, setButtonText] = useState("日時を選択");

    const [, setDisplaySearchDate] = useAtom(displaySearchDateAtom);

    const [datePickerSelectedRange, setDatePickerSelectedRange] = useAtom(
        datePickerSelectedRangeAtom,
    );

    const [searchDateActiveIndex, setSearchDateActiveIndex] = useAtom(
        searchDateActiveIndexAtom,
    );

    const displayTextInModal = () => {
        const { from, to } = datePickerSelectedRange || {};

        const formatDateString = (date: Date) => {
            return format(date, "yyyy/MM/dd");
        };

        if (!from) {
            return <p>日時が選択されていません</p>;
        }

        const fromDateText = formatDateString(from);
        const toDateText = to ? formatDateString(to) : null;

        return to ? (
            fromDateText === toDateText ? (
                <p>{fromDateText}のライブを検索します。</p>
            ) : (
                <p>
                    {fromDateText}から
                    <br />
                    {toDateText}のライブを検索します。
                </p>
            )
        ) : (
            <p>{fromDateText}のライブを検索します。</p>
        );
    };

    useEffect(() => {
        const { from, to } = datePickerSelectedRange || {};

        const formatDateString = (date: Date) => {
            return format(date, "yyyy/MM/dd");
        };

        if (!from) {
            return setButtonText("日時を選択");
        }

        const fromDateText = formatDateString(from);
        const toDateText = to ? formatDateString(to) : null;

        return to
            ? fromDateText === toDateText
                ? setButtonText(fromDateText)
                : setButtonText(`${fromDateText} ~ ${toDateText}`)
            : setButtonText(fromDateText);
    }, [datePickerSelectedRange]);

    const handleItemSelect = (index: number, variant: string) => {
        if (index === searchDateActiveIndex) {
            setSearchDateActiveIndex(null, "reset");
            return;
        }
        setSearchDateActiveIndex(index, variant);
    };

    const handelCancel = () => {
        setModalOpen(false);
    };

    const handelSubmitDatePickerSelectedRange = () => {
        setModalOpen(false);
        if (
            datePickerSelectedRange === undefined ||
            datePickerSelectedRange.from === undefined ||
            datePickerSelectedRange.to === undefined
        ) {
            return;
        }

        setDisplaySearchDate({
            startDate: datePickerSelectedRange.from,
            endDate: datePickerSelectedRange.to,
        });
    };

    return (
        <>
            <div className={styles.container}>
                <div className={styles.item_container}>
                    <div
                        className={`${styles.selector_item} ${
                            searchDateActiveIndex === 0 ? styles.active : ""
                        }`}
                        onClick={() => {
                            handleItemSelect(0, "today");
                        }}
                    >
                        今日
                    </div>
                </div>
                <div className={styles.item_container}>
                    <div
                        className={`${styles.selector_item} ${
                            searchDateActiveIndex === 1 ? styles.active : ""
                        }`}
                        onClick={() => {
                            handleItemSelect(1, "tomorrow");
                        }}
                    >
                        明日
                    </div>
                </div>
                <div className={styles.item_container}>
                    <div
                        className={`${styles.selector_item} ${
                            searchDateActiveIndex === 2 ? styles.active : ""
                        }`}
                        onClick={() => {
                            handleItemSelect(2, "thisWeek");
                        }}
                    >
                        今週
                    </div>
                </div>
            </div>
            <div className={baseStyles.mb8} />
            <div
                className={`${styles.selector_item} ${styles.single} ${
                    searchDateActiveIndex === 3 ? styles.active : ""
                }`}
                onClick={handleModalOpen}
            >
                {!datePickerSelectedRange && (
                    <img
                        src={CalendarIcon}
                        alt=""
                        className={styles.calendar_icon}
                    />
                )}
                {buttonText}
                {!datePickerSelectedRange && (
                    <div className={styles.arrow_icon} />
                )}
            </div>

            <Sheet
                isOpen={isModalOpen}
                onClose={() => {
                    return setModalOpen(false);
                }}
                detent="content-height"
            >
                <Sheet.Container>
                    <Sheet.Content>
                        <Sheet.Scroller>
                            <DayPicker
                                mode="range"
                                locale={ja}
                                selected={datePickerSelectedRange}
                                onSelect={(newRange) => {
                                    setDatePickerSelectedRange(newRange);
                                }}
                                footer={
                                    <>
                                        <div className={baseStyles.mb16} />
                                        <div
                                            className={
                                                styles.day_picker_footer_preview_text
                                            }
                                        >
                                            {displayTextInModal()}
                                        </div>
                                        <p className={styles.hint}>
                                            ※範囲選択も可能です
                                        </p>
                                        <div className={baseStyles.mb16} />
                                        <div
                                            className={
                                                styles.day_picker_footer_buttons_container
                                            }
                                        >
                                            <div
                                                className={`${styles.day_picker_footer_button} ${styles.cancel}`}
                                                onClick={handelCancel}
                                                onKeyDown={handelCancel}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                キャンセル
                                            </div>
                                            <div
                                                className={`${styles.day_picker_footer_button} ${styles.register}`}
                                                onClick={
                                                    handelSubmitDatePickerSelectedRange
                                                }
                                            >
                                                決定
                                            </div>
                                        </div>
                                    </>
                                }
                                styles={{
                                    root: {
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    },
                                    footer: {
                                        width: "308px",
                                    },
                                }}
                            />
                        </Sheet.Scroller>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onTap={handleModalClose} />
            </Sheet>
        </>
    );
};

export default DateTimeSelectorOfFilterModalSheet;
